<ion-header>
  <ion-toolbar>
    <ion-back-button text="" slot="start" (click)="close()"></ion-back-button>
    <ion-title>{{article?.description ?? 'Artikel'}}</ion-title>

    @if(wawiConnectorSrv.connector.executable){
      <ion-buttons slot="end" [title]="'In ' + wawiConnectorSrv.appName + ' öffnen'">
        <ion-button (click)="openArticle()" style="box-shadow: none;">
          <ion-icon slot="icon-only" name="wawitogo"></ion-icon>
        </ion-button>
      </ion-buttons>
    }

  </ion-toolbar>
</ion-header>


<ion-content class="ion-padding">

  <div id="article-information" class="box">
    <h2 class="label" *ngIf="article?.number"><span>Artikelnummer:</span> {{article?.number}}</h2>
    <h2 class="label"><span>Bezeichnung:</span> {{article?.description}}</h2>

    <ion-item>
      <ion-label>Anzahl</ion-label>
      <input slot="end" type="number" [(ngModel)]="article.quantity" style="width: 80px; height: 32px;"/>
    </ion-item>
    <ion-item>
      <ion-toggle mode="ios" style="width: 100%;" slot="end" [(ngModel)]="article.toCalculate">Berechnen</ion-toggle>
    </ion-item>
    <!-- <ion-item *ngIf="isNew">
      <ion-label>Artikeltext übernehmen</ion-label>
      <ion-toggle slot="end"></ion-toggle>
    </ion-item> -->
  </div>

  <div id="serial-numbers" class="box" *ngIf="article?.serialNumbersRequired">

    <h2 style="margin-top: 10px;">Seriennummern: <span>( <span 
      [ngClass]="{'green-font': serialNumberCount == article?.quantity, 'red-font': serialNumberCount > article?.quantity, 'yellow-font': serialNumberCount > 0 && serialNumberCount < article?.quantity}">
      {{serialNumberCount}}</span> / {{article?.quantity ?? 0}} )</span></h2>

    @if(article.serialNumbers.length === 0){
      <p class="no-content">Keine Seriennummern erfasst</p>
    }
    @else {
      <div id="serial-numbers-wrapper">
        <div class="serial-number" *ngFor="let serialNumber of article.serialNumbers">
          <div class="serial-number-number">
            <div class="hover-bttn" (click)="deleteSerialNumber(serialNumber)">
              <ion-icon name="fa-x-mark"></ion-icon>
            </div>
            {{serialNumber?.serialNumber}}
          </div>
          <input type="number" [(ngModel)]="serialNumber.quantity"/>
        </div>
      </div>
    }
    

    <div id="serial-number-add-container">
      <input type="text" placeholder="Seriennummer eingeben..." [(ngModel)]="serialNumberText" (keydown.enter)="addSerialNumber()"/>
      <div class="hover-bttn" (click)="addSerialNumber()">
        <ion-icon name="fa-plus"></ion-icon>
      </div>

      @if(platform.is('capacitor')){
        <div class="hover-bttn" (click)="scanSerialNumber()">
          <ion-icon name="fa-scan"></ion-icon>
        </div>
      }
    </div>

  </div>

  


</ion-content>


<ion-footer>
  <ion-toolbar class="ion-padding" style="padding-top: 0;">
    <ion-button mode="ios" (click)="save()">
      Speichern
    </ion-button>
  </ion-toolbar>
</ion-footer>